var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { selectHasActiveDiscountForBuildingId } from "../../selectors/selectDiscountEvent";
import { selectBuildingLevelInfo } from "../../selectors/selectExistingBuildingInfo";
import { selectIsTutorialBuilding } from "../../selectors/selectTutorial";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { BuildingStateType } from "../../utils/network/generated/protoTypes";
import { utilBuildings } from "../../utils/utilBuildings";
import { ShopCategoryType } from "../balancing/types/BalancingCore";
import { bugsnagClient } from "../bugsnag/bugsnagClient";
import { ErrorBoundary } from "../generic/ErrorBoundary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionBuildingsDeselect, actionBuildingsStartMove, actionBuildingsStartUpgrade, } from "../player-base/buildings/actionBuildings";
import { TypeBuildingAction } from "../player-base/buildings/reducerBuildings";
import { ViewportWorldSpace } from "../viewport/ViewportWorldSpace";
import { ContextMenuBuffableRunningProductionDOM } from "./ContextMenuBuffableRunningProductionDOM";
import { ContextMenuBuffedRunningProductionDOM } from "./ContextMenuBuffedRunningProductionDOM";
import { ContextMenuDetails } from "./ContextMenuDetails";
import { ContextMenuRunningConstructionDOM } from "./ContextMenuRunningConstructionDOM";
import { ContextMenuRunningProductionDOM } from "./ContextMenuRunningProductionDOM";
import { ContextMenuStartProductionDOM } from "./ContextMenuStartProductionDOM";
var ContextMenu = /** @class */ (function (_super) {
    __extends(ContextMenu, _super);
    function ContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onError = function () {
            var onError = _this.props.onError;
            if (onError) {
                onError();
            }
        };
        _this.renderMenu = function (viewport) {
            var building = _this.props.building;
            if (!building) {
                return React.createElement(React.Fragment, null);
            }
            var ContextMenuComponent = _this.getContextMenuComponent(building);
            var _a = _this.props, onInfo = _a.onInfo, onMove = _a.onMove, onUpgrade = _a.onUpgrade, canUpgrade = _a.canUpgrade, canMove = _a.canMove, hasDiscount = _a.hasDiscount, showBouncingArrow = _a.showBouncingArrow;
            var hoverPosition = utilBuildings.getHoverPositionOnScreen(building, viewport);
            var rootPosition = utilBuildings.getRootPositionOnScreen(building, viewport);
            var descriptionDisplay = _this.getDescriptionDisplay();
            var rootStyle = {
                left: hoverPosition.x + "px",
                position: "absolute",
                top: rootPosition.y + "px",
            };
            return (React.createElement(React.Fragment, null,
                React.createElement(ContextMenuDetails, { position: hoverPosition, building: building, descriptionDisplay: descriptionDisplay, onInfo: onInfo, onUpgrade: onUpgrade, onMove: onMove, canUpgrade: canUpgrade, canMove: canMove, hasDiscount: hasDiscount, showBouncingArrow: showBouncingArrow }),
                React.createElement("div", { className: "context-menu-fixed", style: rootStyle }, ContextMenuComponent && React.createElement(ContextMenuComponent, { building: building }))));
        };
        _this.getDescriptionDisplay = function () {
            var building = _this.props.building;
            if (!building) {
                return;
            }
            var level = utilBuildings.getProtoStage(building, 1);
            var buildingStages = building.balancing.stage;
            var happiness = buildingStages[level - 1].happiness || 0;
            var shouldShowLevel = happiness <= 0 || buildingStages.length > 1;
            var shouldShowHappiness = happiness > 0;
            var levelLocaReplacements = new Map([[ReplacementLoca.zero_0, level.toString()]]);
            var happinessLocaReplacements = new Map([[ReplacementLoca.zero_0, happiness.toString()]]);
            var descriptionDisplay = shouldShowLevel && (React.createElement(TextLoca, { id: IdLoca.stageX, replacements: levelLocaReplacements }));
            if (shouldShowLevel && shouldShowHappiness) {
                var proportionalLocaReplacements = new Map([
                    [ReplacementLoca.zero_0, utilLoca.get(IdLoca.stageX, levelLocaReplacements)],
                    [ReplacementLoca.one_1, utilLoca.get(IdLoca.xHappiness, happinessLocaReplacements)],
                ]);
                descriptionDisplay = (React.createElement(TextLoca, { id: IdLoca.value_proportional_value, replacements: proportionalLocaReplacements }));
            }
            else if (shouldShowHappiness) {
                descriptionDisplay = (React.createElement(TextLoca, { id: IdLoca.xHappiness, replacements: happinessLocaReplacements }));
            }
            return descriptionDisplay;
        };
        _this.getContextMenuComponent = function (building) {
            var proto = building.proto, balancing = building.balancing, production = building.production;
            var buildingLevel = balancing.stage[proto.stage - 1];
            var ContextMenuComponent;
            if (proto.state != undefined && proto.state !== BuildingStateType.IDLE) {
                ContextMenuComponent = ContextMenuRunningConstructionDOM;
            }
            else if (production) {
                if (buildingLevel.boostRecipeIDs != undefined) {
                    if (production.production && production.production.boosterId != undefined) {
                        ContextMenuComponent = ContextMenuBuffedRunningProductionDOM;
                    }
                    else {
                        ContextMenuComponent = ContextMenuBuffableRunningProductionDOM;
                    }
                }
                else {
                    ContextMenuComponent = ContextMenuRunningProductionDOM;
                }
            }
            else if (buildingLevel && buildingLevel.recipeIDs) {
                ContextMenuComponent = ContextMenuStartProductionDOM;
            }
            return ContextMenuComponent;
        };
        return _this;
    }
    ContextMenu.prototype.render = function () {
        var _this = this;
        var shouldRender = this.props.shouldRender;
        if (!shouldRender) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(ErrorBoundary, { client: bugsnagClient.bugsnag, name: "ContextMenuDOM.tsx", beforeSend: this.onError },
            React.createElement("div", { className: "context-menu-dom" },
                React.createElement(ViewportWorldSpace, null, function (viewport) { return _this.renderMenu(viewport); }))));
    };
    return ContextMenu;
}(React.PureComponent));
var mapState = function (state) {
    var _a = state.playerBase.buildings, action = _a.action, building = _a.building;
    // Only assigning to building when viewport is not panning.
    var selectedBuilding = action === TypeBuildingAction.Select ? building : undefined;
    var isQuickSellOpen = state.modals.modalStack.some(function (val) { return val.modalId === IdModal.QuickSell; });
    var showBouncingArrow = state.playerBase.buildings.showBouncingArrow || false;
    var isTutorialBuilding = selectIsTutorialBuilding(state, selectedBuilding);
    var canUpgrade = false;
    var canMove = false;
    var hasDiscount = false;
    var shouldRender = !!selectedBuilding && !isQuickSellOpen && isTutorialBuilding;
    if (selectedBuilding != undefined) {
        var buildingState = selectedBuilding.proto.state || BuildingStateType.IDLE;
        var levelsToAdd = buildingState === BuildingStateType.UPGRADING ? 2 : 1;
        var nextLevel = selectBuildingLevelInfo(state, selectedBuilding.balancing.id, utilBuildings.getProtoStage(selectedBuilding) + levelsToAdd);
        canUpgrade = nextLevel !== undefined && buildingState !== BuildingStateType.DEMOLISHING;
        canMove = selectedBuilding.balancing.shopCategory !== ShopCategoryType.Fence;
        hasDiscount = selectHasActiveDiscountForBuildingId(state, selectedBuilding.balancing.id);
    }
    return {
        building: selectedBuilding,
        canMove: canMove,
        canUpgrade: canUpgrade,
        hasDiscount: hasDiscount,
        shouldRender: shouldRender,
        showBouncingArrow: showBouncingArrow,
    };
};
var mapDispatch = function (dispatch) { return ({
    onError: function () { return dispatch(actionBuildingsDeselect()); },
    onInfo: function () { return dispatch(actionModalOpen(IdModal.BuildingInfo)); },
    onMove: function (building) { return dispatch(actionBuildingsStartMove(building)); },
    onUpgrade: function (building) { return dispatch(actionBuildingsStartUpgrade(building)); },
}); };
export var ContextMenuDOM = connect(mapState, mapDispatch)(ContextMenu);



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/ContextMenuDOM.tsx
// module id = 2238
// module chunks = 3